export default __webpack_public_path__ + "static/media/testimonial_list.93206ca5.png";